export default __webpack_public_path__ + "static/media/avatar-preview.6d81dc74.jpg";